import { Code, Database, Layout, Lightbulb } from "lucide-react";
import { Images } from "../assets/images";

const About = () => {
  return (
    <section id="about" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            À propos de moi
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto mb-8"></div>
          <p className="text-lg text-foreground/80">
            Développeur fullstack passionné par la création d'applications web
            modernes et performantes. Je viens de terminer ma formation en
            développement fullstack Node.js et je suis à la recherche de
            nouvelles opportunités pour mettre en pratique mes compétences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="bg-card rounded-lg p-8 shadow-lg transform transition-transform hover:scale-105">
            <div className="flex flex-col md:flex-row items-center mb-6">
              <div className="w-24 h-24 rounded-full overflow-hidden mb-4 md:mb-0 md:mr-6 border-2 border-primary/20">
                <img
                  src={Images.hero2}
                  alt="Yankoua Ivan au travail"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-2xl font-bold">Mon parcours</h3>
            </div>
            <p className="text-foreground/70 mb-6">
              Après avoir découvert ma passion pour le développement web, j'ai
              décidé de me former aux technologies modernes du web. J'ai suivi
              une formation intensive en développement fullstack, où j'ai acquis
              des compétences solides en HTML, CSS, JavaScript, et Node.js. J'ai
              également appris à utiliser des frameworks comme Express et
              NestJS, ainsi que des outils de modélisation UML pour l'analyse de
              projets.
            </p>
            <p className="text-foreground/70">
              Ma formation m'a permis de développer une approche méthodique de
              la résolution de problèmes et une capacité à apprendre rapidement
              de nouvelles technologies. Je suis maintenant prêt à relever de
              nouveaux défis et à contribuer à des projets innovants.
            </p>
          </div>

          <div className="bg-card rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-4">Ce que je fais</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="mr-4 bg-primary/10 p-3 rounded-md">
                  <Code className="text-primary" size={24} />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">
                    Développement Frontend
                  </h4>
                  <p className="text-foreground/70">
                    Création d'interfaces utilisateur réactives et intuitives
                    avec HTML, CSS, JavaScript et React.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="mr-4 bg-primary/10 p-3 rounded-md">
                  <Database className="text-primary" size={24} />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">
                    Développement Backend
                  </h4>
                  <p className="text-foreground/70">
                    Conception d'APIs robustes et évolutives avec Node.js,
                    Express et NestJS.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="mr-4 bg-primary/10 p-3 rounded-md">
                  <Layout className="text-primary" size={24} />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">UI/UX Design</h4>
                  <p className="text-foreground/70">
                    Création d'expériences utilisateur fluides et esthétiques,
                    centrées sur l'utilisateur.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="mr-4 bg-primary/10 p-3 rounded-md">
                  <Lightbulb className="text-primary" size={24} />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">
                    Analyse de Projets
                  </h4>
                  <p className="text-foreground/70">
                    Modélisation UML et analyse efficace des besoins pour des
                    solutions adaptées.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
